import { getAccessToken } from "./tokenAccessor";

// @shared can't import a per-app generated api-client, so we restate only the slice of the
// openapi-generator typescript-fetch `Middleware.pre` contract we use: the request `url` + `init`,
// passed through. Each app's generated `Configuration` accepts it structurally (its `Middleware.pre`
// is method-bivariant and `post`/`onError` are optional). Escape hatch if a future generator
// diverges: export a token helper here and keep a thin per-app Middleware wrapper instead.
interface FetchContext {
  url: string;
  init: RequestInit;
}

interface AuthMiddleware {
  pre(context: FetchContext): Promise<FetchContext>;
}

export const authMiddleware: AuthMiddleware = {
  pre(context) {
    const token = getAccessToken();
    if (token) {
      // The generated client always builds headers as a plain record; the cast keeps the spread a
      // record-merge (RequestInit.headers' broad HeadersInit type would otherwise flag it).
      context.init.headers = {
        ...(context.init.headers as Record<string, string>),
        Authorization: `Bearer ${token}`,
      };
    }
    return Promise.resolve(context);
  },
};
